import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Card, Grid } from '@mui/material';

import InterventionsTable from '../../interventions/InterventionsTable';
import InterventionsFilters from '../../interventions/InterventionsFilters';
import InterventionsExport from '../../interventions/InterventionsExport';
import securedPage from '../../securedPage';
import roles from '../../../constants/roles';
import { loadInterventionsList } from '../../../actions/InterventionActions';
import { CardHeader } from '../../utils';
import HierarchicalSearch from '../../commons/HierarchicalSearch';
import Hidden from '@mui/material/Hidden';
import { withPageTitle } from '../../../utils/page-title';

const InterventionListPage = ({ totalElements }) => (
  <Grid container spacing={3}>
    <HierarchicalSearch loadActionCreator={loadInterventionsList} />
    <Grid item xs={12}>
      <InterventionsFilters calendar={false} map={false} />
    </Grid>
    <Grid item xs={12}>
      <Card>
        <CardHeader
          actions={
            <Hidden mdDown>
              <InterventionsExport />
            </Hidden>
          }
        >
          Interventions{totalElements > 0 ? ` (${totalElements})` : ''}
        </CardHeader>
        <InterventionsTable />
      </Card>
    </Grid>
  </Grid>
);

const stateToProps = ({
  interventions: {
    pagination: { totalElements },
  },
}) => ({
  totalElements,
});
export default compose(
  withPageTitle(() => 'Interventions'),
  securedPage(roles.intervention.view.code),
  connect(stateToProps),
)(InterventionListPage);
